import React, { useState, useEffect, useCallback } from "react";
import {
  Paper,
  Typography,
  Button,
  Switch,
  FormControlLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  Box,
  Tabs,
  Tab,
} from "@material-ui/core";
import { Delete, Edit, Add } from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const GATILHOS = [
  { v: "comment", t: "Comentário no post", d: "Alguém comenta a palavra-chave" },
  { v: "dm", t: "Mensagem no direct", d: "Alguém manda a palavra-chave na DM" },
  { v: "story", t: "Resposta de story", d: "Alguém responde seu story" },
  { v: "mention", t: "Menção", d: "Alguém te menciona num post ou comentário" },
];

const VAZIA = {
  trigger: "comment",
  dmButtons: "",
  dmSequence: "",
  flowId: "",
  name: "",
  mediaId: "",
  keywords: "",
  replyPublic: "",
  replyDirect: "",
  likeComment: false,
  requireFollow: false,
  followAskText: "",
  followRewardText: "",
  gateButtonText: "",
  active: true,
};

const InstagramPage = () => {
  const [aba, setAba] = useState(0);
  const [regras, setRegras] = useState([]);
  const [leads, setLeads] = useState([]);
  const [ativo, setAtivo] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(VAZIA);
  // Publicacoes da conta. O cliente escolhe numa lista em vez de descobrir
  // que o codigo da URL nao e o mesmo id que o webhook manda.
  const [postsDaConta, setPostsDaConta] = useState([]);
  const [carregandoPosts, setCarregandoPosts] = useState(false);
  const [erroPosts, setErroPosts] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [fluxos, setFluxos] = useState([]);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get("/instagram/rules");
      setRegras(data.regras || []);
      setAtivo(!!data.ativo);
    } catch (e) {
      toast.error("Não foi possível carregar as automações.");
    }
  }, []);

  const carregarLeads = useCallback(async () => {
    try {
      const { data } = await api.get("/instagram/leads");
      setLeads(data || []);
    } catch (e) {
      /* silencioso */
    }
  }, []);

  useEffect(() => {
    carregar();
    carregarLeads();
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        const lista = data?.flows || data || [];
        setFluxos(Array.isArray(lista) ? lista : []);
      } catch (e) {
        /* seletor de fluxo fica vazio, o resto funciona */
      }
    })();
  }, [carregar, carregarLeads]);

  // Botoes e sequencia sao guardados como JSON no banco
  const lerLista = (v) => {
    try {
      const p = typeof v === "string" && v ? JSON.parse(v) : v;
      return Array.isArray(p) ? p : [];
    } catch (e) {
      return [];
    }
  };
  const gravarLista = (chave, lista) =>
    setForm((f) => ({ ...f, [chave]: JSON.stringify(lista) }));

  const alternarModulo = async (v) => {
    try {
      await api.post("/instagram/toggle", { ativo: v });
      setAtivo(v);
      toast.success(v ? "Automações ligadas." : "Automações desligadas.");
    } catch (e) {
      toast.error("Não foi possível alterar.");
    }
  };

  const abrirNova = () => {
    setForm(VAZIA);
    setModal("create");
  };
  const abrirEdicao = (r) => {
    setForm({ ...VAZIA, ...r });
    setModal("edit");
  };

  const salvar = async () => {
    if (!String(form.name).trim()) {
      toast.error("Dê um nome para a automação.");
      return;
    }
    setSalvando(true);
    try {
      if (modal === "edit") {
        await api.put(`/instagram/rules/${form.id}`, form);
      } else {
        await api.post("/instagram/rules", form);
      }
      toast.success("Automação salva.");
      setModal(null);
      carregar();
    } catch (e) {
      toast.error(e?.response?.data?.error || "Erro ao salvar.");
    }
    setSalvando(false);
  };

  const excluir = async (r) => {
    if (!window.confirm(`Excluir a automação "${r.name}"?`)) return;
    try {
      await api.delete(`/instagram/rules/${r.id}`);
      toast.success("Excluída.");
      carregar();
    } catch (e) {
      toast.error("Erro ao excluir.");
    }
  };

  const campo = (label, chave, extra = {}) => (
    <TextField
      label={label}
      value={form[chave] || ""}
      onChange={(e) => setForm({ ...form, [chave]: e.target.value })}
      fullWidth
      size="small"
      variant="outlined"
      style={{ marginTop: 14 }}
      {...extra}
    />
  );

  const dica = { fontSize: 11.5, color: "#6b7280", display: "block", marginTop: 4 };

  // Editor dos botoes de link. Vive em dois lugares: solto (sem a trava de
  // seguir) ou dentro do passo da entrega (com a trava), que e onde ele
  // realmente faz sentido para quem esta montando.
  // Estilos dos passos e do preview do direct
  // Contas do Instagram conectadas, para a pessoa escolher de qual sao os posts
  useEffect(() => {
    api.get("/whatsapp", { params: { session: 0 } })
      .then(({ data }) => {
        const contas = (data || []).filter(w => w.channel === "instagram");
        setContasIg(contas);
        if (contas.length === 1) setContaIg(contas[0].id);
        const pgs = (data || []).filter(w => w.channel === "facebook");
        setContasFb(pgs);
        if (pgs.length === 1) setContaFb(pgs[0].id);
      })
      .catch(() => {});
  }, []);

  const carregarPosts = async () => {
    if (carregandoPosts) return;
    setCarregandoPosts(true);
    setErroPosts("");
    try {
      const ehFb = canalModeracao === "facebook";
      const { data } = await api.get(ehFb ? "/facebook/posts" : "/instagram/posts", {
        params: { conexaoId: (ehFb ? contaFb : contaIg) || undefined }
      });
      setPostsDaConta(data.posts || []);
      if (data.erro === "sem_conexao") {
        setErroPosts("Conecte uma conta do Instagram em Canais para listar os posts.");
      } else if (data.erro) {
        setErroPosts("Não consegui listar as publicações agora.");
      }
    } catch (e) {
      setErroPosts("Não consegui listar as publicações agora.");
    }
    setCarregandoPosts(false);
  };

  const caixaPasso = {
    background: "#fff",
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    border: "1px solid #e9d5ff"
  };
  const tituloPasso = {
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 4
  };
  const numeroPasso = {
    background: "#7c3aed",
    color: "#fff",
    borderRadius: "50%",
    width: 20,
    height: 20,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    flexShrink: 0
  };
  const balao = {
    background: "#f9fafb",
    borderRadius: 10,
    padding: 10,
    marginTop: 10,
    borderLeft: "3px solid #d8b4fe"
  };
  const textoBalao = {
    fontSize: 12,
    color: "#374151",
    whiteSpace: "pre-wrap",
    marginBottom: 6
  };
  const botaoFalso = {
    border: "1px solid #d1d5db",
    borderRadius: 16,
    padding: "4px 10px",
    fontSize: 11,
    color: "#4b5563",
    textAlign: "center",
    marginTop: 4,
    background: "#fff"
  };

  const renderBotoesDM = (titulo, ajuda, estilo) => (
          <Box style={estilo}>
            <Typography style={{ fontSize: 13, fontWeight: 600 }}>{titulo}</Typography>
            <Typography style={dica}>{ajuda}</Typography>
            {lerLista(form.dmButtons).map((b, i) => (
              <Box key={i} style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <TextField
                  placeholder="Texto do botão"
                  value={b.titulo || ""}
                  onChange={(e) => {
                    const l = lerLista(form.dmButtons);
                    l[i] = { ...l[i], titulo: e.target.value };
                    gravarLista("dmButtons", l);
                  }}
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 20 }}
                  style={{ width: 170 }}
                />
                <TextField
                  placeholder="https://..."
                  value={b.url || ""}
                  onChange={(e) => {
                    const l = lerLista(form.dmButtons);
                    l[i] = { ...l[i], url: e.target.value };
                    gravarLista("dmButtons", l);
                  }}
                  size="small"
                  variant="outlined"
                  style={{ flex: 1 }}
                />
                <IconButton
                  size="small"
                  onClick={() => {
                    const l = lerLista(form.dmButtons);
                    l.splice(i, 1);
                    gravarLista("dmButtons", l);
                  }}
                >
                  <Delete fontSize="small" style={{ color: "#dc2626" }} />
                </IconButton>
              </Box>
            ))}
            {lerLista(form.dmButtons).length < 3 && (
              <Button
                size="small"
                startIcon={<Add />}
                onClick={() =>
                  gravarLista("dmButtons", [
                    ...lerLista(form.dmButtons),
                    { titulo: "", url: "" },
                  ])
                }
                style={{ textTransform: "none", marginTop: 8 }}
              >
                Adicionar botão
              </Button>
            )}
          </Box>
  );


  const [checando, setChecando] = useState(false);
  const [diag, setDiag] = useState(null);

  // Moderacao de comentarios
  const [canalModeracao, setCanalModeracao] = useState("instagram");
  const [contasFb, setContasFb] = useState([]);
  const [contaFb, setContaFb] = useState("");
  const [contasIg, setContasIg] = useState([]);
  const [contaIg, setContaIg] = useState("");
  const [moderarPost, setModerarPost] = useState("");
  const [comentarios, setComentarios] = useState([]);
  const [carregandoComentarios, setCarregandoComentarios] = useState(false);
  const [respostaDe, setRespostaDe] = useState(null);
  const [textoResposta, setTextoResposta] = useState("");
  const [ocupado, setOcupado] = useState(null);

  const carregarComentarios = async (mediaId) => {
    if (!mediaId) return;
    setCarregandoComentarios(true);
    try {
      const ehFb = canalModeracao === "facebook";
      const { data } = await api.get(ehFb ? "/facebook/comentarios" : "/instagram/comentarios", {
        params: ehFb
          ? { postId: mediaId, conexaoId: contaFb || undefined }
          : { mediaId, conexaoId: contaIg || undefined }
      });
      setComentarios(Array.isArray(data) ? data : []);
    } catch (err) {
      toastError(err);
      setComentarios([]);
    } finally {
      setCarregandoComentarios(false);
    }
  };

  const escolherPost = async (mediaId) => {
    setModerarPost(mediaId);
    setRespostaDe(null);
    setTextoResposta("");
    await carregarComentarios(mediaId);
  };

  const responderComentario = async (commentId) => {
    if (!textoResposta.trim()) {
      toast.warning("Escreva a resposta");
      return;
    }
    setOcupado(commentId);
    try {
      await api.post(canalModeracao === "facebook" ? "/facebook/comentarios/responder" : "/instagram/comentarios/responder", {
        commentId,
        mensagem: textoResposta.trim(),
        conexaoId: contaIg || undefined
      });
      toast.success("Resposta publicada");
      setRespostaDe(null);
      setTextoResposta("");
      await carregarComentarios(moderarPost);
    } catch (err) {
      toastError(err);
    } finally {
      setOcupado(null);
    }
  };

  const alternarOculto = async (c) => {
    setOcupado(c.id);
    try {
      await api.post(canalModeracao === "facebook" ? "/facebook/comentarios/ocultar" : "/instagram/comentarios/ocultar", {
        commentId: c.id,
        ocultar: !c.oculto,
        conexaoId: (canalModeracao === "facebook" ? contaFb : contaIg) || undefined,
        // vao junto para o comentario continuar legivel depois de oculto
        texto: c.texto,
        autor: c.autor
      });
      toast.success(c.oculto ? "Comentário reexibido" : "Comentário ocultado");
      await carregarComentarios(moderarPost);
    } catch (err) {
      toastError(err);
    } finally {
      setOcupado(null);
    }
  };

  const curtirComentario = async (commentId) => {
    setOcupado(commentId);
    try {
      await api.post("/instagram/comentarios/curtir", { commentId, conexaoId: contaIg || undefined });
      toast.success("Comentário curtido");
      // Sem recarregar, o contador continua o antigo e parece que nao foi.
      await carregarComentarios(moderarPost);
    } catch (err) {
      toastError(err);
    } finally {
      setOcupado(null);
    }
  };

  const apagarComentario = async (commentId) => {
    setOcupado(commentId);
    try {
      await api.delete(
        canalModeracao === "facebook"
          ? `/facebook/comentarios/${commentId}`
          : `/instagram/comentarios/${commentId}`,
        { params: { conexaoId: (canalModeracao === "facebook" ? contaFb : contaIg) || undefined } }
      );
      toast.success("Comentário apagado");
      await carregarComentarios(moderarPost);
    } catch (err) {
      toastError(err);
    } finally {
      setOcupado(null);
    }
  };

  const conferir = async () => {
    setChecando(true);
    try {
      const { data } = await api.get("/instagram/diagnostico");
      setDiag(data);
    } catch (err) {
      toastError(err);
    } finally {
      setChecando(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <div>
          <Typography variant="h5" style={{ fontWeight: 700 }}>
            Automações do Instagram
          </Typography>
          <Typography style={dica}>
            Alguém comenta uma palavra no seu post e recebe a resposta e a mensagem no
            direct, automaticamente.
          </Typography>
        </div>
        <FormControlLabel
          control={
            <Switch
              checked={ativo}
              onChange={(e) => alternarModulo(e.target.checked)}
              color="primary"
            />
          }
          label={ativo ? "Ligado" : "Desligado"}
        />
      </Box>

      {/* Comentei e não aconteceu nada */}
      <Box
        style={{
          border: "1px solid #e5e7eb", borderRadius: 10, padding: 14,
          marginBottom: 16, background: "#fafafa"
        }}
      >
        <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
          <Typography style={{ fontSize: 13, color: "#374151" }}>
            Comentou no post e não aconteceu nada? Confira o que está faltando.
          </Typography>
          <Button variant="outlined" size="small" onClick={conferir} disabled={checando}>
            {checando ? "Conferindo..." : "Conferir agora"}
          </Button>
        </Box>

        {diag && (
          <Box style={{ marginTop: 12 }}>
            <Typography style={{ fontSize: 13, fontWeight: 700, marginBottom: 8,
              color: diag.pronto ? "#15803d" : "#b45309" }}>
              {diag.pronto
                ? "Tudo certo — os comentários chegam aqui."
                : "Falta um passo para os comentários chegarem."}
            </Typography>
            {(diag.passos || []).map((p, i) => (
              <Box key={i} style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 8 }}>
                <span style={{ fontSize: 14, lineHeight: "20px" }}>{p.ok ? "✅" : "⚠️"}</span>
                <Box>
                  <Typography style={{ fontSize: 13, fontWeight: 600 }}>{p.nome}</Typography>
                  <Typography style={{ fontSize: 12, color: "#6b7280" }}>{p.detalhe}</Typography>
                  {!p.ok && p.comoResolver && (
                    <Typography style={{ fontSize: 12, color: "#b45309", marginTop: 2 }}>
                      {p.comoResolver}
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>

      {/* Moderação de comentários */}
      <Box
        style={{
          border: "1px solid #e5e7eb", borderRadius: 10, padding: 16,
          marginBottom: 16, background: "#fff"
        }}
      >
        <Typography style={{ fontSize: 15, fontWeight: 700, marginBottom: 2 }}>
          Comentários
        </Typography>
        <Typography style={{ ...dica, marginBottom: 12 }}>
          Responda, oculte ou apague os comentários dos seus posts sem sair daqui.
        </Typography>

        <Box style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <Select
            value={canalModeracao}
            onChange={(e) => {
              setCanalModeracao(e.target.value);
              setPostsDaConta([]);
              setModerarPost("");
              setComentarios([]);
            }}
            variant="outlined"
            style={{ minWidth: 150 }}
          >
            <MenuItem value="instagram">Instagram</MenuItem>
            <MenuItem value="facebook">Facebook</MenuItem>
          </Select>

          {canalModeracao === "facebook" && contasFb.length > 1 && (
            <Select
              value={contaFb}
              onChange={(e) => {
                setContaFb(e.target.value);
                setPostsDaConta([]);
                setModerarPost("");
                setComentarios([]);
              }}
              displayEmpty
              variant="outlined"
              style={{ minWidth: 220 }}
            >
              <MenuItem value=""><em>Escolha a Página</em></MenuItem>
              {contasFb.map((c) => (
                <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
              ))}
            </Select>
          )}

          {canalModeracao === "instagram" && contasIg.length > 1 && (
            <Select
              value={contaIg}
              onChange={(e) => {
                setContaIg(e.target.value);
                setPostsDaConta([]);
                setModerarPost("");
                setComentarios([]);
              }}
              displayEmpty
              variant="outlined"
              style={{ minWidth: 220 }}
            >
              <MenuItem value="">
                <em>Escolha a conta</em>
              </MenuItem>
              {contasIg.map((c) => (
                <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
              ))}
            </Select>
          )}
          <Select
            value={moderarPost}
            onChange={(e) => escolherPost(e.target.value)}
            displayEmpty
            variant="outlined"
            style={{ minWidth: 320 }}
            onOpen={carregarPosts}
          >
            <MenuItem value="">
              <em>Escolha um post</em>
            </MenuItem>
            {postsDaConta.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {(p.legenda || "(sem legenda)").slice(0, 60)}
              </MenuItem>
            ))}
          </Select>
          {moderarPost && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => carregarComentarios(moderarPost)}
              disabled={carregandoComentarios}
            >
              {carregandoComentarios ? "Carregando..." : "Atualizar"}
            </Button>
          )}
        </Box>

        {moderarPost && !carregandoComentarios && comentarios.length === 0 && (
          <Typography style={{ ...dica, marginTop: 12 }}>
            Nenhum comentário nesse post.
          </Typography>
        )}

        {comentarios.map((c) => (
          <Box
            key={c.id}
            style={{
              borderTop: "1px solid #f1f5f9", paddingTop: 12, marginTop: 12,
              opacity: c.oculto ? 0.55 : 1
            }}
          >
            <Box style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
              <Box style={{ flex: 1, minWidth: 220 }}>
                <Typography style={{ fontSize: 13, fontWeight: 700 }}>
                  @{c.autor}
                  {c.oculto && (
                    <span style={{ fontWeight: 400, color: "#b45309", marginLeft: 8, fontSize: 12 }}>
                      oculto
                    </span>
                  )}
                </Typography>
                <Typography style={{ fontSize: 14 }}>{c.texto}</Typography>
                <Typography style={{ fontSize: 12, color: "#64748b" }}>
                  {c.curtidas > 0 ? `♥ ${c.curtidas}` : "♡ 0"}
                  {c.respostas > 0 ? ` · ${c.respostas} resposta(s)` : ""}
                </Typography>
              </Box>
              <Box style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                <Button
                  size="small"
                  onClick={() => { setRespostaDe(respostaDe === c.id ? null : c.id); setTextoResposta(""); }}
                  disabled={ocupado === c.id}
                >
                  Responder
                </Button>
                {canalModeracao === "instagram" && (() => {
                  const curtidoNaTela = (c.curtidas || 0) > 0;
                  return (
                    <Button
                      size="small"
                      onClick={() => curtirComentario(c.id)}
                      disabled={ocupado === c.id}
                      style={{ color: curtidoNaTela ? "#e0245e" : undefined }}
                    >
                      {curtidoNaTela ? "♥ Curtido" : "♡ Curtir"}
                    </Button>
                  );
                })()}
                <Button size="small" onClick={() => alternarOculto(c)} disabled={ocupado === c.id}>
                  {c.oculto ? "Reexibir" : "Ocultar"}
                </Button>
                <Button
                  size="small"
                  style={{ color: "#dc2626" }}
                  onClick={() => apagarComentario(c.id)}
                  disabled={ocupado === c.id}
                >
                  Apagar
                </Button>
              </Box>
            </Box>

            {respostaDe === c.id && (
              <Box style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  autoFocus
                  placeholder="Sua resposta pública"
                  value={textoResposta}
                  onChange={(e) => setTextoResposta(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => responderComentario(c.id)}
                  disabled={ocupado === c.id}
                >
                  Enviar
                </Button>
              </Box>
            )}
          </Box>
        ))}
      </Box>

      {!ativo && (
        <Paper style={{ padding: 12, marginBottom: 14, background: "#fff7ed", border: "1px solid #fed7aa" }}>
          <Typography style={{ fontSize: 13, color: "#9a3412" }}>
            As automações estão <b>desligadas</b>. Os comentários são apenas registrados,
            nada é enviado. Ligue quando a conta do Instagram estiver conectada.
          </Typography>
        </Paper>
      )}

      <Tabs value={aba} onChange={(e, v) => setAba(v)} indicatorColor="primary" textColor="primary">
        <Tab label={`Automações (${regras.length})`} />
        <Tab label={`Quem comentou (${leads.length})`} />
      </Tabs>

      {aba === 0 && (
        <>
          <Button variant="contained" color="primary" onClick={abrirNova} style={{ margin: "14px 0", textTransform: "none" }}>
            Nova automação
          </Button>

          {regras.length === 0 && (
            <Paper style={{ padding: 24, textAlign: "center", color: "#6b7280" }}>
              Nenhuma automação criada ainda.
            </Paper>
          )}

          {regras.map((r) => (
            <Paper key={r.id} style={{ padding: 14, marginBottom: 10 }}>
              <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Box style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <Typography style={{ fontWeight: 700 }}>{r.name}</Typography>
                    {!r.active && <Chip size="small" label="pausada" />}
                    {r.requireFollow && <Chip size="small" label="exige seguir" style={{ background: "#ede9fe" }} />}
                    {r.likeComment && <Chip size="small" label="curte" style={{ background: "#fce7f3" }} />}
                    <Chip size="small" label={`${r.hitCount || 0} disparos`} style={{ background: "#dcfce7" }} />
                  </Box>
                  <Typography style={dica}>
                    Palavras: <b>{r.keywords || "(qualquer comentário)"}</b>
                    {r.mediaId ? ` · post ${r.mediaId}` : " · todos os posts"}
                  </Typography>
                  {r.replyPublic && (
                    <Typography style={dica}>Responde: “{String(r.replyPublic).slice(0, 70)}”</Typography>
                  )}
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                  <IconButton size="small" onClick={() => abrirEdicao(r)}>
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={() => excluir(r)}>
                    <Delete fontSize="small" style={{ color: "#dc2626" }} />
                  </IconButton>
                </div>
              </Box>
            </Paper>
          ))}
        </>
      )}

      {aba === 1 && (
        <Paper style={{ marginTop: 14 }}>
          {leads.length === 0 ? (
            <div style={{ padding: 24, textAlign: "center", color: "#6b7280" }}>
              Ninguém comentou ainda.
            </div>
          ) : (
            leads.map((l) => (
              <div key={l.id} style={{ padding: 12, borderBottom: "1px solid #f1f5f9" }}>
                <b>@{l.username || "sem nome"}</b>{" "}
                <span style={{ color: "#6b7280", fontSize: 12 }}>
                  {l.regraNome ? `· ${l.regraNome}` : ""}
                  {l.follows === true ? " · segue" : l.follows === false ? " · não segue" : ""}
                  {l.rewardSent ? " · recebeu" : ""}
                </span>
                <div style={{ fontSize: 13, color: "#374151" }}>{l.commentText}</div>
              </div>
            ))
          )}
        </Paper>
      )}

      <Dialog open={!!modal} onClose={() => setModal(null)} maxWidth="sm" fullWidth scroll="paper">
        <DialogTitle>{modal === "create" ? "Nova automação" : "Editar automação"}</DialogTitle>
        <DialogContent dividers>
          {campo("Nome da automação", "name", { placeholder: "Ex: Receita grátis" })}

          <TextField
            select
            label="Quando disparar"
            value={form.trigger || "comment"}
            onChange={(e) => setForm({ ...form, trigger: e.target.value })}
            fullWidth
            size="small"
            variant="outlined"
            style={{ marginTop: 14 }}
          >
            {GATILHOS.map((g) => (
              <MenuItem key={g.v} value={g.v}>
                {g.t}
              </MenuItem>
            ))}
          </TextField>
          <Typography style={dica}>
            {(GATILHOS.find((g) => g.v === (form.trigger || "comment")) || {}).d}
          </Typography>

          {campo("Palavras-chave (separadas por vírgula)", "keywords", {
            placeholder: "eu quero, quero, receita",
          })}
          <Typography style={dica}>
            Vazio = qualquer comentário dispara. Palavras com até 3 letras só valem
            quando escritas sozinhas.
          </Typography>

          <Box style={{ marginTop: 8 }}>
            <Typography style={{ fontSize: 13, fontWeight: 600 }}>
              Em qual publicação?
            </Typography>
            <Typography style={dica}>
              Deixe em <b>Todas</b> para valer em qualquer post. Escolher um post na
              lista é o jeito seguro — colar o código da URL não funciona, porque o
              Instagram usa outro identificador por dentro.
            </Typography>

            <Select
              value={form.mediaId || ""}
              onChange={(e) => setForm({ ...form, mediaId: e.target.value })}
              onOpen={carregarPosts}
              displayEmpty
              fullWidth
              variant="outlined"
              style={{ marginTop: 6 }}
            >
              <MenuItem value="">Todas as publicações</MenuItem>
              {carregandoPosts && (
                <MenuItem value="__carregando" disabled>
                  Carregando publicações...
                </MenuItem>
              )}
              {!carregandoPosts &&
                !postsDaConta.length &&
                form.mediaId && (
                  <MenuItem value={form.mediaId}>
                    Publicação já escolhida ({form.mediaId})
                  </MenuItem>
                )}
              {postsDaConta.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {p.thumb ? (
                      <img
                        src={p.thumb}
                        alt=""
                        style={{ width: 34, height: 34, objectFit: "cover", borderRadius: 4 }}
                      />
                    ) : null}
                    <Box>
                      <Typography style={{ fontSize: 12 }}>
                        {p.legenda || `(sem legenda) · ${p.tipo}`}
                      </Typography>
                      <Typography style={{ fontSize: 10, color: "#9ca3af" }}>
                        {p.data ? new Date(p.data).toLocaleDateString("pt-BR") : ""}
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              ))}
            </Select>

            {erroPosts ? (
              <Typography style={{ ...dica, color: "#dc2626" }}>{erroPosts}</Typography>
            ) : null}

            <Typography style={{ ...dica, marginTop: 6 }}>
              Não achou na lista? Cole o link do post aqui que eu traduzo:
            </Typography>
            <TextField
              placeholder="https://www.instagram.com/p/..."
              size="small"
              variant="outlined"
              fullWidth
              onBlur={(e) => {
                const v = e.target.value.trim();
                if (v) setForm({ ...form, mediaId: v });
              }}
            />
          </Box>


          {campo("Resposta pública no comentário", "replyPublic", {
            multiline: true,
            minRows: 2,
            placeholder: "Mandei no seu direct, {{usuario}}! 💚",
          })}
          <Typography style={dica}>
            Use <b>{"{{usuario}}"}</b> para citar quem comentou e{" "}
            <b>{"{{comentario}}"}</b> para repetir o que a pessoa escreveu.
          </Typography>

          {campo("Mensagem no direct", "replyDirect", {
            multiline: true,
            minRows: 2,
            placeholder: "Oi! Aqui está o que prometi 👇",
          })}

          <FormControlLabel
            style={{ marginTop: 10 }}
            control={
              <Switch
                checked={!!form.likeComment}
                onChange={(e) => setForm({ ...form, likeComment: e.target.checked })}
                color="primary"
              />
            }
            label={<span style={{ fontSize: 13 }}>Curtir o comentário</span>}
          />

          <FormControlLabel
            control={
              <Switch
                checked={!!form.requireFollow}
                onChange={(e) => setForm({ ...form, requireFollow: e.target.checked })}
                color="primary"
              />
            }
            label={<span style={{ fontSize: 13 }}>Só liberar o conteúdo para quem segue</span>}
          />

          {form.requireFollow && (
            <Box style={{ background: "#faf5ff", padding: 14, borderRadius: 8, marginTop: 8 }}>
              <Typography style={{ fontSize: 12, color: "#6b21a8", marginBottom: 14 }}>
                A mensagem vai para <b>todo mundo</b> que comentar, seguindo ou não — é
                assim que a automação ganha seguidor. Quem ainda não segue recebe um
                convite antes do conteúdo.
              </Typography>

              {/* PASSO 1 */}
              <Box style={caixaPasso}>
                <Typography style={tituloPasso}>
                  <span style={numeroPasso}>1</span> A pessoa comenta e recebe isto
                </Typography>
                <Typography style={dica}>
                  O texto é o da <b>Mensagem no direct</b>, ali em cima. Aqui você só
                  escolhe o que vai escrito no botão.
                </Typography>
                {campo("Texto do botão", "gateButtonText", {
                  placeholder: "Quero o link",
                  inputProps: { maxLength: 20 },
                })}
                <Box style={balao}>
                  <Typography style={textoBalao}>
                    {form.replyDirect || "Oi! Vi seu comentário 💚"}
                  </Typography>
                  <Box style={botaoFalso}>{form.gateButtonText || "Quero o link"}</Box>
                </Box>
              </Box>

              {/* PASSO 2 */}
              <Box style={caixaPasso}>
                <Typography style={tituloPasso}>
                  <span style={numeroPasso}>2</span> Tocou no botão e <u>ainda não segue</u>
                </Typography>
                {campo("", "followAskText", {
                  multiline: true,
                  minRows: 2,
                  placeholder: "Falta pouco! Me segue aqui e toca em Já segui 💚",
                })}
                <Typography style={dica}>
                  Os botões <b>Seguir</b> e <b>Já segui</b> são automáticos — você não
                  precisa criar, eles já vão junto.
                </Typography>
                <Box style={balao}>
                  <Typography style={textoBalao}>
                    {form.followAskText ||
                      "Falta pouco! Me segue aqui e toca em Já segui 💚"}
                  </Typography>
                  <Box style={{ display: "flex", gap: 6 }}>
                    <Box style={{ ...botaoFalso, flex: 1 }}>Seguir</Box>
                    <Box style={{ ...botaoFalso, flex: 1 }}>Já segui</Box>
                  </Box>
                </Box>
              </Box>

              {/* PASSO 3 */}
              <Box style={{ ...caixaPasso, marginBottom: 0 }}>
                <Typography style={tituloPasso}>
                  <span style={numeroPasso}>3</span> <u>Já segue</u> — aqui entrega o conteúdo
                </Typography>
                {campo("", "followRewardText", {
                  multiline: true,
                  minRows: 2,
                  placeholder: "Prontinho, obrigado por seguir! Aqui está 👇",
                })}
                {renderBotoesDM(
                  "Botão de entrega",
                  "É aqui que entra o link do que você prometeu. Até 3 botões.",
                  { marginTop: 10 }
                )}
                <Box style={balao}>
                  <Typography style={textoBalao}>
                    {form.followRewardText ||
                      "Prontinho, obrigado por seguir! Aqui está 👇"}
                  </Typography>
                  {lerLista(form.dmButtons).filter((b) => b.titulo).length ? (
                    lerLista(form.dmButtons)
                      .filter((b) => b.titulo)
                      .map((b, i) => (
                        <Box key={i} style={botaoFalso}>
                          {b.titulo}
                        </Box>
                      ))
                  ) : (
                    <Box style={{ ...botaoFalso, color: "#dc2626", borderColor: "#fca5a5" }}>
                      sem botão — a pessoa não recebe o link
                    </Box>
                  )}
                </Box>
              </Box>

              <Typography style={{ ...dica, color: "#7c3aed", marginTop: 12 }}>
                Se a Meta não informar se a pessoa segue, o conteúdo é entregue mesmo
                assim — melhor liberar a mais do que travar quem seguiu de verdade.
              </Typography>
            </Box>
          )}

          {!form.requireFollow &&
            renderBotoesDM(
              "Botões na mensagem",
              "Até 3 botões com link. Aparecem junto da mensagem no direct.",
              { marginTop: 16, paddingTop: 12, borderTop: "1px solid #e5e7eb" }
            )}

          <Box style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #e5e7eb" }}>
            <Typography style={{ fontSize: 13, fontWeight: 600 }}>
              Sequência de mensagens
            </Typography>
            <Typography style={dica}>
              Mensagens enviadas depois da primeira, com intervalo. O tempo conta a
              partir da mensagem anterior.
            </Typography>
            {lerLista(form.dmSequence).map((p, i) => (
              <Box key={i} style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "flex-start" }}>
                <TextField
                  type="number"
                  label="min"
                  value={p.minutos || ""}
                  onChange={(e) => {
                    const l = lerLista(form.dmSequence);
                    l[i] = { ...l[i], minutos: e.target.value };
                    gravarLista("dmSequence", l);
                  }}
                  size="small"
                  variant="outlined"
                  inputProps={{ min: 1 }}
                  style={{ width: 90 }}
                />
                <TextField
                  placeholder="Mensagem"
                  value={p.texto || ""}
                  onChange={(e) => {
                    const l = lerLista(form.dmSequence);
                    l[i] = { ...l[i], texto: e.target.value };
                    gravarLista("dmSequence", l);
                  }}
                  size="small"
                  variant="outlined"
                  multiline
                  style={{ flex: 1 }}
                />
                <IconButton
                  size="small"
                  onClick={() => {
                    const l = lerLista(form.dmSequence);
                    l.splice(i, 1);
                    gravarLista("dmSequence", l);
                  }}
                >
                  <Delete fontSize="small" style={{ color: "#dc2626" }} />
                </IconButton>
              </Box>
            ))}
            <Button
              size="small"
              startIcon={<Add />}
              onClick={() =>
                gravarLista("dmSequence", [
                  ...lerLista(form.dmSequence),
                  { minutos: 60, texto: "" },
                ])
              }
              style={{ textTransform: "none", marginTop: 8 }}
            >
              Adicionar mensagem
            </Button>
          </Box>

          <TextField
            select
            label="Continuar num fluxo do construtor (opcional)"
            value={form.flowId || ""}
            onChange={(e) => setForm({ ...form, flowId: e.target.value })}
            fullWidth
            size="small"
            variant="outlined"
            style={{ marginTop: 16 }}
          >
            <MenuItem value="">Não usar fluxo</MenuItem>
            {fluxos.map((f) => (
              <MenuItem key={f.id} value={f.id}>
                {f.name}
              </MenuItem>
            ))}
          </TextField>
          <Typography style={dica}>
            Com um fluxo escolhido, a conversa continua no construtor — dá para usar
            pergunta, condição, IA e o resto dos blocos.
          </Typography>

          <FormControlLabel
            style={{ marginTop: 10 }}
            control={
              <Switch
                checked={form.active !== false}
                onChange={(e) => setForm({ ...form, active: e.target.checked })}
                color="primary"
              />
            }
            label={<span style={{ fontSize: 13 }}>Automação ativa</span>}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModal(null)}>Cancelar</Button>
          <Button onClick={salvar} color="primary" variant="contained" disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InstagramPage;
